// Types
import { GetInventoryInfo_inventoryInfo } from "api/Medicine/types/GetInventoryInfo";
// Helpers
import { isKilos, isLitres } from "../utils";
import { getBatchUnit } from "../getBatchUnit";

/**
 * @description returns the default unit for unit field based on known exceptions
 * @param batch the batch object
 */
export const getDefaultUnit = (batch: GetInventoryInfo_inventoryInfo): string => {
  const unit = getBatchUnit(batch);

  if (isLitres(unit)) return "ml";
  if (isKilos(unit)) return "g";

  return unit;
};
